import { AbstractControl, ValidatorFn } from "@angular/forms";

export function CpeCuiValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {


        const codVer = {
            0: "T", 1: "R", 2: "W", 3: "A", 4: "G", 5: "M", 6: "Y", 7: "F", 8: "P", 9: "D",
            10: "X", 11: "B", 12: "N", 13: "J", 14: "Z", 15: "S", 16: "Q", 17: "V",
            18: "H", 19: "L", 20: "C", 21: "K", 22: "E"
        };
        let charA = "";
        let charB = "";
        const regex = /[A-Z]{2}/;

        let valid = false;
        const sCPE = control.value.trim().toUpperCase();

        if (sCPE && sCPE.length === 20
            && sCPE.substring(0, 2) === "PT" // First two characters must match PT.
            && !isNaN(sCPE.substring(2, 18)) // The sixteen characters after the first two must be digits.
            && regex.test(sCPE.substring(18))
        ) {
            valid = true;
            let x = parseInt(sCPE.substring(2, 18), 10);
            x = x % 529;
            const y = Math.floor(x / 23);
            const z = x % 23;
            if (z < 23 && y < 23) {
                charA = codVer[y];
                charB = codVer[z];
                if ((charA !== sCPE.substring(18, 19)) || charB !== sCPE.substring(19, 20)) {
                    valid = false;
                }
            } else {
                valid = false;
            }
        }

        return valid ? null : { cpecui: { value: control.value } };
    };
}
